import { Component, Inject } from '@angular/core';
import { Product } from '../../Model/product';
import { WebOrderDeliveryTimeSlotSetup } from '../../Model/web-order-delivery-time-slot-setup';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../../services/toast.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-delivery-time-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonExternalModule],
  templateUrl: './delivery-time-dialog.component.html',
  styleUrl: './delivery-time-dialog.component.css'
})
export class DeliveryTimeDialogComponent {

  product: Product = new Product();
  productList: Product[] = [];
  webOrderDeliveryTimeSlotSetup: WebOrderDeliveryTimeSlotSetup[] = [];
  deliveryDate: any;
  deliveryTime: any;
  defaultDate: any;
  maxDeliveryDate: any;
  minimumDeliveryTime: any;

  constructor(
    public dialogRef: MatDialogRef<DeliveryTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private toastService: ToastService,
  ) {
    console.log(dialogData)
    // if (dialogData && dialogData.productList)
    //   this.productList = dialogData.productList;
    // if (dialogData && dialogData.deliveryTimeSlotSetup)
    //   this.dateChanged()
    this.productList = dialogData.productList || [];
    this.webOrderDeliveryTimeSlotSetup = dialogData.deliveryTimeSlotSetup || [];
    this.minimumDeliveryTime = this.dialogData.minimumDeliveryTime;

    // Optional: initialize from first product
    if (this.productList.length > 0) {
      this.deliveryDate = this.productList[0].deliveryDate ?? this.productList[0].defaultDate;
      this.deliveryTime = this.productList[0].deliveryTime;
      this.defaultDate = this.productList[0].defaultDate;
      this.maxDeliveryDate = this.productList[0].maxDeliveryDate;
    }

    this.dateChanged();
  }

  ngOnInit(): void {
  }

  // dateChanged() {
  //   this.product.deliveryDate = this.product.deliveryDate ? moment(this.product.deliveryDate).format("YYYY-MM-DD") : null;
  //   if (this.product.defaultDate == this.product.deliveryDate) {
  //     this.webOrderDeliveryTimeSlotSetup = this.dialogData.deliveryTimeSlotSetup.filter(e => this.product.defaultTimeSlotAvl.includes(e.timeSlot));
  //   }
  //   else {
  //     this.webOrderDeliveryTimeSlotSetup = this.dialogData.deliveryTimeSlotSetup;
  //   }

  //   if (!this.webOrderDeliveryTimeSlotSetup.some(e => e.timeSlot == this.product.deliveryTime)) {
  //     this.product.deliveryTime = this.webOrderDeliveryTimeSlotSetup[0]?.timeSlot;
  //   }

  // }

  dateChanged() {

    this.deliveryDate = this.deliveryDate
      ? moment(this.deliveryDate).format("YYYY-MM-DD")
      : null;

    const firstProduct = this.productList[0];

    if (!firstProduct) {
      return;
    }

    // Future date => all slots
    if (this.deliveryDate !== firstProduct.defaultDate) {

      this.webOrderDeliveryTimeSlotSetup = [
        ...this.dialogData.deliveryTimeSlotSetup
      ];

    } else {

      // Minimum delivery date => filter using current time
      const now = moment();

      const hours = Number(this.minimumDeliveryTime.split(':')[0]);
      const minutes = Number(this.minimumDeliveryTime.split(':')[1]);

      const minimumDeliveryMoment = now
        .clone()
        .add(hours, 'hours')
        .add(minutes, 'minutes');

      const currentMinutes =
        minimumDeliveryMoment.hours() * 60 +
        minimumDeliveryMoment.minutes();

      this.webOrderDeliveryTimeSlotSetup =
        this.dialogData.deliveryTimeSlotSetup.filter(slot => {

          const fromMinutes =
            Number(slot.timeSlot.split("-")[0].split(":")[0]) * 60 +
            Number(slot.timeSlot.split("-")[0].split(":")[1]);

          return fromMinutes > currentMinutes;
        });
    }

    if (
      !this.webOrderDeliveryTimeSlotSetup.some(
        s => s.timeSlot === this.deliveryTime
      )
    ) {
      this.deliveryTime =
        this.webOrderDeliveryTimeSlotSetup[0]?.timeSlot;
    }
  }

  // onConfirmClick() {
  //   this.product.deliveryDate = moment(this.product.deliveryDate).format("YYYY-MM-DD");
  //   if (this.product.deliveryTime) {
  //     this.dialogRef.close({ data: this.product });
  //   }
  //   else {
  //     this.toastService.showErrorToast('Choose Delivery Slot');
  //   }
  // }

  onConfirmClick() {

    if (!this.deliveryTime) {
      this.toastService.showErrorToast('Choose Delivery Slot');
      return;
    }

    this.productList.forEach(product => {
      product.deliveryDate = moment(this.deliveryDate).format("YYYY-MM-DD");
      product.deliveryTime = this.deliveryTime;
    });

    this.dialogRef.close({
      data: this.productList
    });
  }

}
